import { useMemo } from "react";
import { Flex, ScrollArea } from "@radix-ui/themes";
import { StopwatchIcon } from "@radix-ui/react-icons";
import ActivityTimeline from "@/components/activity-timeline";
import { InteractionEvent as InteractionEventType } from "@/v2/entities/interaction-event/InteractionEvent.model";
import { convertDataToActivityEvents } from "@/v2/entities/interaction-event/InteractionEvent.utils";
import { InteractionViewTabContentEmptyState } from "../parts/InteractionViewTabContentEmptyStateProps";

interface InteractionEventProps {
  data: InteractionEventType[];
}

export function InteractionEvent({ data }: InteractionEventProps) {
  const events = useMemo(() => convertDataToActivityEvents(data), [data]);

  if (events.length === 0) {
    return (
      <InteractionViewTabContentEmptyState
        icon={<StopwatchIcon />}
        title="No activity yet"
        description="Any updates or AI actions will show up here."
      />
    );
  }

  return (
    <Flex height={"100%"} direction={"column"} overflow={"hidden"}>
      <ScrollArea scrollbars="vertical">
        <Flex pt={"4"} px={"6"} direction={"column"}>
          <ActivityTimeline events={events} />
        </Flex>
      </ScrollArea>
    </Flex>
  );
}
